class MobileMenuTabs extends HTMLElement {
  connectedCallback() {
    this.initialize();
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');

    if (tab && this.contains(tab)) {
      this.selectTab(tab);
      return;
    }

    const accordionButton = event.target.closest('.mobile-menu-tabs__accordion-button');

    if (accordionButton && this.contains(accordionButton)) {
      this.toggleAccordion(accordionButton);
    }
  };

  onKeydown = (event) => {
    const tab = event.target.closest('[role="tab"]');

    if (!tab || !this.contains(tab) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      return;
    }

    const tabs = [...this.querySelectorAll('[role="tab"]')];
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    tabs[nextIndex].focus();
    this.selectTab(tabs[nextIndex]);
  };

  selectTab(tab) {
    const panelId = tab.getAttribute('aria-controls');

    this.querySelectorAll('[role="tab"]').forEach((item) => {
      const isSelected = item === tab;
      item.setAttribute('aria-selected', String(isSelected));
      item.tabIndex = isSelected ? 0 : -1;
    });

    this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  }

  toggleAccordion(button) {
    const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (isExpanded && panel?.contains(document.activeElement)) button.focus();

    button.setAttribute('aria-expanded', String(!isExpanded));
    if (panel) panel.hidden = isExpanded;
  }

  initialize() {
    const selectedTab = this.querySelector('[role="tab"][aria-selected="true"]') || this.querySelector('[role="tab"]');

    if (selectedTab) this.selectTab(selectedTab);

    this.querySelectorAll('.mobile-menu-tabs__accordion-button').forEach((button) => {
      const panel = this.querySelector(`#${button.getAttribute('aria-controls')}`);

      button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }
}

if (!window.customElements.get('mobile-menu-tabs')) {
  window.customElements.define('mobile-menu-tabs', MobileMenuTabs);
}
